import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type ItemDisplayState<TFilter> = {
    id: string,
    itemsDisplayed: number,
    filters: TFilter,
    isFilterModalOpen: boolean,
    scrollY: number
}

export type ItemDisplaySliceState = Record<string, ItemDisplayState<any>>;

const initialState: ItemDisplaySliceState = {};

export const itemDisplaySlice = createSlice({
    name: 'itemDisplaySlice',
    initialState: initialState,
    reducers: {
        clearDisplayState: (state) => {
            Object.keys(state).forEach(key => {
                delete state[key];
            })
        },
        setDisplayState: (state, action: PayloadAction<ItemDisplayState<any>>) => {
            state[action.payload.id] = action.payload;
        }
    }
});

export const {
    setDisplayState,
    clearDisplayState
} = itemDisplaySlice.actions;

export default itemDisplaySlice.reducer;